export default __webpack_public_path__ + "static/media/lock-icon.a096d971.svg";